<template>
	<div id="app" ref="vueApp" style="display:none;">
		<div class="mala-content clearfix" :class="topStyle[$route.meta.keepAlive - 1]" v-if="appPage === 1">
			<!-- 头部导航 -->
			<Topmenu></Topmenu>
			<!-- 左侧导航 -->
			<Myleft v-if="$route.meta.leftShow" ref="left"></Myleft>
			<div class="right-div" ref="child" :style="!$route.meta.leftShow ? 'margin-left:0;' : ''">
				<!-- 跟方案有关的显示 -->
				<router-view v-if="isPlan != '' && $route.meta.planCut"></router-view>
				<!-- 跟方案无关显示 -->
				<router-view v-if="!$route.meta.planCut"></router-view>
			</div>
		</div>
		<!-- 维护页面 -->
		<div class="maintain-warp" v-if="appPage === 0">
			<div class="maintain">
				<img src="static/images/maintain.png" class="img">
				<p>{{ pageTips }}</p>
			</div>
		</div>
		<!-- 提示弹框 -->
		<Dialog ref="tipsModal" type="alert" level="1">
			<div slot="mdBox">
				<p class="ac" v-html="tipsHtml"></p>
			</div>
		</Dialog>
		<modal :title="`${versionInfo.version}版本更新`" :visible.sync="visible" @confirm="sureEditor()" confirmText="我知道了"
			width="600px" :showCancel="false">
			<div class="d-flex" v-html="versionInfo.desc"></div>
		</modal>
		<!-- loading -->
		<div class="loadBox ac" v-show="showLoad">
			<div class="loadCont">
				<img :src="baseUrl + '/static/images/loading1.gif'" />
				<p>{{ loadHtml }}</p>
			</div>
		</div>
		<div style="position:fiexd;z-index:-1;opacity:0">{{ showToast }}</div>
		<!-- 预警提示弹框 -->
		<div class="caution-mask" ref="cautionMask"
			v-if="cautionList.newsList && cautionStorage != 1 && cautionList.newsList.length > 0">
			<a class="close" href="javascript:void(0);" @click="closeCaution();"><img
					:src="baseUrl + '/static/images/close.png'" class="db" /></a>
			<div class="caution-header">
				<span class="fl">预警通知</span>
				<span class="fr">今日新增预警（<i class="color-red">{{ cautionList.numFound }}</i>条）</span>
			</div>
			<div class="caution-body">
				<ul class="caution-new">
					<li v-for="(item, index) in cautionList.newsList" :key="index">
						<router-link class="color-3d3d4c" target="_blank"
							:to="{ path: baseUrl + '/detail', query: { data: item.newsId + ',' + item.newsSimHash + ',' + item.startDate + ',' + item.endDate } }">
							<h3 class="article-title ovhidden"><span class="tag"
									:class="attributeType[item.newsEmotion]">{{ item.newsEmotion }}</span><span>{{ item.newsTitle }}</span>
							</h3>
						</router-link>
						<p class="ziduan color-8a8a99">
							<span>发布时间：{{ item.newsPosttime }}</span>
							<span>来源：{{ item.platformName }}</span>
						</p>
					</li>
				</ul>
			</div>
		</div>
		<!-- 会员过期提示 -->
		<!-- 到期弹窗 -->
		<Dialog ref="expireVip" type="normal" level="1" :callback="sureRenew"
			:btnText="expireRemindButtons.confrimText == '' ? expireRemindButtons.cancelText : expireRemindButtons.confrimText"
			@cancelVip="cancelVip">
			<div slot="mdBox">
				<p class="ac">{{ expireRemind }}</p>
			</div>
		</Dialog>
		<div class="newBan" @click="goOld">
			<i class="iconfont icon-qiehuan" style="font-size:26px;line-height:36px;"></i>
			<div>新版</div>
		</div>
	</div>
</template>

<script>
import Dialog from '@/components/dialog'
import Myleft from '@/components/left'
import Topmenu from '@/components/topMenu'
import modal from '@/components/versionDialog.vue'
import {
	mapState,
	mapGetters
} from 'vuex';
export default {
	components: {
		Myleft,
		Topmenu,
		Dialog,
		modal
	},
	computed: {
		...mapState({
			showToast: state => state.show.showToast,
		}),
		...mapGetters(['configInfo'])
	},
	name: 'App',
	data() {
		return {
			cooke: '', //登录标识
			appPage: '', //app入口页面显示类型
			pageTips: '', //页面提示文字
			baseUrl: this.$baseUrl,
			topStyle: ['home', '', 'white', 'header'],
			icons: {
				'wx': 'wx-icon',
				'web': 'web-icon1',
				'weibo': 'wb-icon1',
				'app': 'app-icon1',
				'bbs': 'bbs-icon1',
				'journal': 'bk-icon1',
				'media_toutiao': 'tt-icon1',
				'media_qq': 'qq-icon1',
				'media_baijia': 'bj-icon1',
				'media_sohu': 'sh-icon1',
				'media_wangyi': 'wy-icon1',
				'media_people': 'people-icon1'
			},
			attributeType: {
				'正面': 'tag-blue',
				'中性': 'tag-orange',
				'负面': 'tag-red',
			}, //属性对应的class样式
			emotionModify: '', //用户是否有修改情感属性得权限 1是有 -1是没有
			expireTime: '', //会员到期时间
			cautionList: '', //底部弹框预警列表
			cautionStorage: '', //判断是否手动关闭了预警弹框
			realmName: '', //域名
			tipsHtml: '', //提示语句
			headImg: '', //用户头像
			newest: false, //最新公告标识
			nickname: '', //用户昵称
			memberTypeName: '', //会员名称
			memberType: '', //会员等级
			timeSection: 90, //数据查询跨度时间
			remainSmsNum: '', //短信剩余量
			isPlan: '', //判断是否有方案
			isMajorAccount: '', //定制大客户页面权限1影藏 2显示
			isSignin: false,
			newNotice: '', //新消息
			notceTips: false, //新消息开关
			remainDownloadNum: '', //下载剩余量
			remainRefreshNum: '',
			showLoad: false,
			isSupportArtificialWarningSet: -1, //是否支持人工预警设置
			isSupportFullTextSearch: -1, //是否支持全文检索
			trialInfoType: '', //判断是否需要强制填写使用信息 1强制填写试用信息 2可填写 3不可填写
			loadHtml: '正在加载...',
			selectOption: [{
				'name': '标题',
				'type': 'news_title'
			},
			{
				'name': '摘要',
				'type': 'news_digest'
			},
			{
				'name': '作者',
				'type': 'news_author'
			},
			{
				'name': '分析词',
				'type': 'keyword_count'
			},
			{
				'name': '发布人',
				'type': 'media_name'
			},
			// { 'name': '认证类型', 'type': 'mediaverifiedtype' },
			{
				'name': '原作者',
				'type': 'news_origin_author_name'
			},
			{
				'name': '主题词',
				'type': 'news_keywords'
			},
			{
				'name': '阅读数',
				'type': 'news_read_count'
			},
			{
				'name': '点赞数',
				'type': 'news_like_count'
			},
			{
				'name': '评论数',
				'type': 'news_comment_count'
			},
			{
				'name': '转发数',
				'type': 'news_reposts_count'
			},
			{
				'name': '粉丝数',
				'type': 'media_followers_count'
			},
			{
				'name': '原文链接',
				'type': 'news_url'
			},
			{
				'name': '发布平台',
				'type': 'platform_name'
			},
			{
				'name': '情感属性',
				'type': 'news_emotion'
			},
			// {'name':'情感分值','type':'news_emotion_score'},
			{
				'name': '提及地区',
				'type': 'news_content_province'
			},
			{
				'name': '发布时间',
				'type': 'news_posttime'
			},
			{
				'name': '发布地区',
				'type': 'media_province'
			},
			{
				'name': '相似文章条数',
				'type': 'sim_count'
			}
			], //全局下载配置
			expireDate: '',
			expireRemind: '', //会员过期提醒
			expireRemindButtons: '',
			versionInfo: {}, //版本弹框数据
			visible: false, //版本弹框显示
      isGray: false
		}
	},
	watch: {
		configInfo: {
			async handler(newVal) {
        this.isGray = newVal.isGray === 1
				this.getversion()
			},
			deep: true,
		},
    isGray(val) {
      if (val) {
        this.$nextTick(() => {
          document.querySelector('html').classList.add('filterGray')
        })
      } else {
        this.$nextTick(() => {
          document.querySelector('html').classList.remove('filterGray')
        })
      }
    }
	},
	mounted() {
		let that = this;
		this.$api.get('open/config', null, r => {
			if (r.data.expireRemind != '') {
				that.expireRemind = r.data.expireRemind;
				that.expireRemindButtons = r.data.expireRemindButtons
				if (r.data.registerCompleteUrl != '') {
					window.location.href = r.data.registerCompleteUrl
				}
				that.$refs.expireVip.showMaskFun();
			}
			that.$store.dispatch('show/getConfigInfo', r.data)
		})

		that.$nextTick(() => {
			that.$refs.vueApp.style.display = 'block';
			// 验证登录信息
			let host = window.location.host;
			if (process.env.NODE_ENV === "development") {
				that.cautionStorage = sessionStorage.getItem('caution');
				that.realmName = 'http://192.168.1.102:8080';
				that.isSignin = true;
				that.getLogin();
			} else {
				that.realmName = 'https://' + host + '';
				that.cautionStorage = sessionStorage.getItem('caution');
				let cooke = document.cookie.indexOf("_gsdataCL=");
				that.cooke = cooke;
				if (cooke != -1) {
					that.isSignin = true;
					that.getCurrplan();
					that.getUserInformation();
				} else {
					if (that.$route.meta.requireAuth) {
						window.location.href = "https://u1.nybkz.com/member/login?url=" + that.realmName + "" +
							that.baseUrl + "/yuYingGather";
					} else { //不要登陆的页面显示
						that.appPage = 1;
					}
				}
			}
			// if(host === 'yuqing_new.nybkz.com' || host === 'oldyuqing.nybkz.com' || host === 'yuqing.nybkz.com' || host === 'yuqing_old_test.nybkz.com'){//线上
			//     that.realmName = 'http://' + host + '';
			//     that.cautionStorage =  sessionStorage.getItem('caution');
			//     let cooke = document.cookie.indexOf("_gsdataCL=");
			// 	that.cooke = cooke;
			//     if(cooke != -1){
			//         that.isSignin = true;
			//         that.getCurrplan();
			//         that.getUserInformation();
			//     }else{
			//         if(that.$route.meta.requireAuth){
			//             window.location.href="https://u1.nybkz.com/member/login?url="+that.realmName+""+that.baseUrl+"/yuYingGather";
			//         }else{//不要登陆的页面显示
			// 			that.appPage = 1;
			// 		}
			//     }
			// }else{//本地

			//     that.cautionStorage =  sessionStorage.getItem('caution');
			//     that.realmName = 'http://192.168.1.102:8080';
			//     that.isSignin = true;
			//     that.getCurrplan();
			//     that.getUserInformation();
			// }
			document.title = that.$route.meta.title
		})
	},
	created() {

	},
	methods: {
		//版本更新弹框是否显示
		getversion() {
			let { versionRemindButtons, versionRemind, version } = this.configInfo
			if (versionRemindButtons && versionRemindButtons.cancelText == '好的') {
				this.versionInfo.desc = versionRemind.replace(/\n/g, '<br>')
				this.versionInfo.version = version
				this.visible = true
			}
		},
		//版本更新弹框点击确认
		async sureEditor() {
			this.visible = false
			this.$api.get('/userCenter/index/close-version-remind')
		},
		//切换老版
		goOld() {
			document.cookie = 'front_version_type=2;path=/';
			setTimeout(() => {
				window.location.href = 'http://' + window.location.host + '/nindex'
			}, 500)
		},
		// 本地登录接口
		getLogin() {
			let that = this;
			that.$api.get('user/index/login', null, r => {
				that.returnCode(r, function () {
					sessionStorage.setItem('Authorization', r.data);
					that.getCurrplan();
					that.getUserInformation();
				});
			})
		},
		//获取当前方案
		getCurrplan() {
			let that = this;
			that.loadModal(true, '数据加载中...');
			that.$api.get('monitor/scheme/show', null, r => {
				that.showLoad = false;
				that.returnCode(r, function () {
					let value = r.data;
					that.curCompetPlan = value.competeInfo;
					if (value.id == '') { //没有方案
						window.sessionStorage.removeItem('planStorage')
						if (that.$route.meta.planCut) {
							that.$router.push({
								path: '' + that.baseUrl + '/buildSolution'
							});
						}
					} else {
						that.isPlan = value;
						sessionStorage.setItem('planStorage', JSON.stringify(value));
						that.$store.dispatch('show/getShowData', value)
						that.getCaution();
						// let redirect = that.$route.query.redirect;
						// that.$router.push({path:redirect});
					}

				});
			})
		},
		// 个人中心获取数据
		getUserInformation() {
			let that = this;
			// that.loadModal(true,'数据加载中...');
			that.$api.get('user/index/index', null, r => {
				that.returnCode(r, function () {
					let value = r.data;
					if (value.oldEntranceAuth != 1) {
						that.goOld()
					}
					that.$sensors.login(value.memberId);
					that.headImg = value.headImg;
					that.expireTime = r.data.expireTime;
					that.nickname = value.nickname;
					that.memberTypeName = value.memberTypeName;
					that.memberType = value.memberType;
					that.remainSmsNum = value.remainSmsNum;
					that.remainDownloadNum = value.remainDownloadNum;
					that.remainRefreshNum = value.remainRefreshNum;
					that.isMajorAccount = value.isMajorAccount;
					that.choiceTimeField = value.choiceTimeField;
					sessionStorage.setItem('userId', value.uid); //储存页面标题的公共部分
					// // 大客户路由验证
					let bigBossRoute = ['' + that.baseUrl + '/renew', '' + that.baseUrl + '/vipBuy',
					'' + that.baseUrl + '/rechargeRecord'
					]; //大客户不显示的路由
					let path = that.$route.path;
					if (bigBossRoute.indexOf(path) != -1 && that.isMajorAccount === 1) {
						that.$router.push({
							'path': '' + that.baseUrl + '/vipRight'
						});
					}
					that.getJurisdiction();

					//that.getNewNotice();
					that.getexpireDate(value.expireTime);

				});
			})
		},
		//计算到期时间七天以内
		getexpireDate(time_) {
			let chaTime = new Date(time_) - new Date();
			let chaDate = Math.ceil(chaTime / 86400000);
			if (chaDate >= 7) {
				this.expireDate = chaDate;
			}
		},
		//关闭续费按钮
		cancelVip() {
			let that = this;
			this.$api.post('user/member/close-expire-remind', null, r => {
				that.$api.get('open/config', null, r => {
					that.$store.dispatch('show/getConfigInfo', r.data)
				})
			});
		},
		//去续费
		sureRenew() {
			let that = this;
			this.$refs.expireVip.closeMask();
			this.$api.post('user/member/close-expire-remind', null, r => {
				that.returnCode(r, function () {
					that.$router.push({
						path: '' + that.baseUrl + '/renew',
						query: {
							memberType: 4,
							form: 'renew'
						}
					})
				});
			});
		},
		// 获取权限
		getJurisdiction() {
			let that = this;
			that.$api.get('user/index/config-index', null, r => {
				that.returnCode(r, function () {
					let data = r.data;
					that.isSupportArtificialWarningSet = data.isSupportArtificialWarningSet;
					that.isSupportFullTextSearch = data.isSupportFullTextSearch;
					that.timeSection = data.searchDays + 1;
					that.trialInfoType = data.trialInfoType;
					that.emotionModify = data.emotionModify;
					sessionStorage.setItem('trialInfoType', data.trialInfoType); //储存页面标题的公共部分
					if (data.trialInfoType === 1 && that.$route.meta.requireAuth) { //1时强制填写
						that.$router.push({
							path: that.baseUrl + '/fillInTrial'
						});
					}
				});
			})
		},
		// 获取公告状态
		getNewNotice() {
			let that = this;
			that.$api.get('user/index/get-unread-notice', null, r => {
				that.returnCode(r, function () {
					if (r.data.num > 0) {
						that.newest = true;
					}
					that.newNotice = r.data.notice;
					if (r.data.notice.length == undefined) {
						that.notceTips = true;
					}
				});
			})
		},
		// 获取预警通知
		getCaution() {
			let that = this;
			if (that.cautionStorage === '1') { //sessionStorage存在就不显示预警
				return;
			}
			that.$api.get('monitor/warning/warn-notice', {
				sid: that.isPlan.id
			}, r => {
				that.returnCode(r, function () {
					that.cautionList = r.data;
				});
			})
		},
		// 关闭预警通知
		closeCaution() {
			this.cautionStorage = '1';
			sessionStorage.setItem('caution', '1');
		},
		loadModal(isShow, txt) {
			let that = this;
			if (txt != '') {
				that.loadHtml = txt;
			}
			that.showLoad = isShow;
		},
		// alert提示
		alertTips(text) {
			this.tipsHtml = text;
			this.$refs.tipsModal.showMaskFun();
		},
		// code判断
		returnCode(data, callback, catchBack) {
			let code = data.code;
			if (code === 10000) {
				callback();
			} else {
				if (code === 10004) { //会员过期
					if ($('.alertText').length <= 0) {
						this.$utils.alertText('会员已过期，请购买会员');
					}
					this.$router.push({
						'path': '' + this.baseUrl + '/vipBuy'
					});
					// window.location.href=""+this.realmName+""+this.baseUrl+"/vipBuy";
				} else if (code === 10003) { //未登录
					let url = window.location.href;
					// this.$sensors.login(this.$sensors.quick('getAnonymousID'));
					// window.location.href = "https://u1.nybkz.com/member/login?url="+url+"";
				} else if (code === 10007) { //大客户错误码
					this.$router.push({
						'path': '' + this.baseUrl + '/vipRight'
					});
				} else if (code === 10008) { //判断老的付费用户
					window.location.href = data.data.url;
				} else if (code === 10011) { //没有开通全文检索
					this.$router.push({
						'path': '' + this.baseUrl + '/productDetail',
						query: {
							id: 18
						}
					});
				} else if (code === 10012) { //进入维护提示页面
					this.appPage = 0;
					this.pageTips = data.msg;
					return;
				} else {
					if (data.msg != undefined) {
						this.$utils.alertText(data.msg);
					}
				}
				this.showLoad = false;
				this.$refs.child.isDisable = false;
				catchBack();
			}
			this.appPage = 1;
		}
	}
}
</script>

<style>
@import "./style/animate.css";
@import '//at.alicdn.com/t/c/font_3865127_hgexa9wo676.css';
@import '//at.alicdn.com/t/font_2708335_sw06kyizs0f.css';
@import "//at.alicdn.com/t/font_2210789_uot6p5u31ac.css";
@import "./style/base.css";
@import "./style/style.css";

.el-cascader-node.in-active-path,
.el-cascader-node.is-active,
.el-cascader-node.is-selectable.in-checked-path {
	color: #0095eb;
}

.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
	background-color: #0095eb;
	border-color: #0095eb;
}

.newBan {
	width: 60px;
	height: 60px;
	text-align: center;
	line-height: 20px;
	color: #fff;
	position: fixed;
	right: 0;
	bottom: 30%;
	background: #5db8f0;
	cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/App.vue